import type { CourseTreeNode } from "@/types/generated";
import type { ImageStoryboard, StoryboardFile } from "@/types/storyboard";
import ImageDemonstration from "@/components/storyboard/image/ImageDemonstration";
import ImageLabeledGraphic from "@/components/storyboard/image/ImageLabeledGraphic";
import { StoryboardFallback } from "@/components/storyboard/StoryboardFallback";

interface Props {
  data: ImageStoryboard & { files?: StoryboardFile[] };
  contentElement: CourseTreeNode;
}

export const StoryboardImageRenderer = ({ data, contentElement }: Props) => {
  switch (data.subType) {
    case "DEMONSTRATION":
      return <ImageDemonstration description={data.description} />;
    case "LABELED_GRAPHIC":
      return (
        <ImageLabeledGraphic
          description={data.description}
          file={data.files ? data.files[0] : undefined}
        />
      );
    default:
      return <StoryboardFallback title={contentElement.title} />;
  }
};
